// Tracking
export const USER_TRACKING = "/user-tracking";

// Sections
export const SECTIONS = "/sections";
export const SECTION_TYPES = "/section-types";

// ***********************************************************************
// Selectables
export const API_CLIENTS_SELECTABLE = "/selectables/clients";
export const API_PLATFORMS_SELECTABLE = "/selectables/platforms";

// ***********************************************************************
// Dashboards - Actions performance
export const DASHBOARDS_ACTIONS_PERFORMANCE_FILTER_SELECTABLES =
  "/dashboard-items/actions-performance/filter-selectables";
export const DASHBOARDS_ACTIONS_PERFORMANCE_METRIC_CHART_SELECTABLES =
  "/dashboard-items/actions-performance/metric-chart-selectables";
export const DASHBOARDS_ACTIONS_PERFORMANCE_GROUPING_DIMENSION_SELECTABLES =
  "/dashboard-items/actions-performance/grouping-dimension-selectables";
export const DASHBOARDS_ACTIONS_PERFORMANCE_KPIS =
  "/dashboard-items/actions-performance/kpis";
export const DASHBOARDS_ACTIONS_PERFORMANCE_METRICS_CHART =
  "/dashboard-items/actions-performance/metrics-chart";
export const DASHBOARDS_ACTIONS_PERFORMANCE_METRICS_CHART_BY_DIMENSION =
  "/dashboard-items/actions-performance/metrics-chart-by-dimension";

// ***********************************************************************
// Dashboards - Data alerts
export const DASHBOARDS_DATA_ALERTS_RECORDS =
  "/dashboard-items/data-alerts/records";
export const DASHBOARDS_DATA_ALERTS_TAG_SELECTABLES =
  "/dashboard-items/data-alerts/tag-selectables";

// ***********************************************************************
// Data explorers - Actions performance
export const DATA_EXPLORERS_ACTIONS_PERFORMANCE_FILTER_SELECTABLES =
  "/data-explorer-items/actions-performance/filter-selectables";
export const DATA_EXPLORERS_ACTIONS_PERFORMANCE_METRICS_DIMENSIONS_SELECTABLES =
  "/data-explorer-items/actions-performance/metrics-dimensions-selectables";
export const DATA_EXPLORERS_ACTIONS_PERFORMANCE_PREVIEW =
  "/data-explorer-items/actions-performance/preview";
export const DATA_EXPLORERS_ACTIONS_PERFORMANCE_DOWNLOAD =
  "/data-explorer-items/actions-performance/download";

// ***********************************************************************
// Data explorers - Tactic lines performance
export const TACTIC_LINES_PERFORMANCE_FILTER_SELECTABLES =
  "/data-explorer-items/tactic-lines-performance/filter-selectables";
export const TACTIC_LINES_PERFORMANCE_KPIS =
  "/data-explorer-items/tactic-lines-performance/kpis";

// ***********************************************************************
// Data explorers - Data library
export const API_DATASETS_LIBRARY =
  "/data-explorer-items/data-library/datasets";
export const API_DATASET_LIBRARY_BY_ID = (id) =>
  `${API_DATASETS_LIBRARY}/${id}`;
export const API_DATASET_DIMENSIONS = (id) =>
  `${API_DATASET_LIBRARY_BY_ID(id)}/dimensions`;
export const API_DATASET_METRICS = (id) =>
  `${API_DATASET_LIBRARY_BY_ID(id)}/metrics`;
export const API_DATASET_DIMENSION_VALUES = (code, dimensionCode) =>
  `${API_DATASET_DIMENSIONS(code)}/${dimensionCode}`;
export const API_DATASET_QUERY = (code) =>
  `${API_DATASET_LIBRARY_BY_ID(code)}/query`;
export const API_DATASET_DOWNLOAD = (code, lang, format) =>
  `${API_DATASET_LIBRARY_BY_ID(code)}/download?lng=${lang}&format=${format}`;
export const API_DATASET_DOWNLOAD_PYTHON = (code) =>
  `${API_DATASET_LIBRARY_BY_ID(code)}/download-python`;
export const API_DATASET_DOWNLOAD_POWERBI = (code) =>
  `${API_DATASET_LIBRARY_BY_ID(code)}/download-powerbi`;

// ***********************************************************************
// Tools - Clients administration
export const CLIENTS_ADMINISTRATION = "/tools-items/clients-administration";
export const CLIENTS_ADMINISTRATION_BY_ID = (id) =>
  `${CLIENTS_ADMINISTRATION}/${id}`;
export const CLIENT_MARKETS = (id) =>
  `${CLIENTS_ADMINISTRATION_BY_ID(id)}/markets`;
export const CLIENT_MARKET = (id, marketId) =>
  `${CLIENT_MARKETS(id)}/${marketId}`;
export const CLIENT_CAMPAIGNS = (id) =>
  `${CLIENTS_ADMINISTRATION_BY_ID(id)}/campaigns`;
export const CLIENT_CAMPAIGN = (id, campaignId) =>
  `${CLIENT_CAMPAIGNS(id)}/${campaignId}`;
export const CLIENT_CATEGORIES = (id) =>
  `${CLIENTS_ADMINISTRATION_BY_ID(id)}/categories`;
export const CLIENT_CATEGORY = (id, categoryId) =>
  `${CLIENT_CATEGORIES(id)}/${categoryId}`;
export const CLIENT_CATEGORIES_SELECTABLE = (id) =>
  `${CLIENT_CATEGORIES(id)}/selectable`;
export const CLIENT_PRODUCTS = (id) =>
  `${CLIENTS_ADMINISTRATION_BY_ID(id)}/products`;
export const CLIENT_PRODUCT = (id, productId) =>
  `${CLIENT_PRODUCTS(id)}/${productId}`;
export const CLIENT_PLATFORMS_SELECTABLE = (id) =>
  `${CLIENTS_ADMINISTRATION_BY_ID(id)}/platforms/selectable`;
export const CLIENT_PLATFORM_MAPPINGS = (id) =>
  `${CLIENTS_ADMINISTRATION_BY_ID(id)}/platformMappings`;
export const CLIENT_PLATFORM_MAPPING = (id, platformMapping) =>
  `${CLIENT_PLATFORM_MAPPINGS(id)}/${platformMapping}`;

// ***********************************************************************
// Tools - Objectives tracker
export const OBJECTIVES_TRACKER = "/tools-items/objectives-trackers";
export const OBJECTIVES_TRACKER_CLIENT_SELECTABLES =
  "/tools-items/objectives-trackers/selectables/clients";
export const OBJECTIVES_TRACKER_DIMENSION_SELECTABLES = (clientId) =>
  `/tools-items/objectives-trackers/selectables/dimensions?client=${clientId}`;
export const OBJECTIVE_TRACKER_BY_ID = (id) => `${OBJECTIVES_TRACKER}/${id}`;
export const OBJECTIVE_TRACKER_PERIODS = (id) =>
  `${OBJECTIVE_TRACKER_BY_ID(id)}/periods`;
export const OBJECTIVE_TRACKER_PERIOD_BY_ID = (trackerId, periodId) =>
  `${OBJECTIVE_TRACKER_PERIODS(trackerId)}/${periodId}`;
export const OBJECTIVE_TRACKER_DUPLICATE_PERIOD = (trackerId, periodId) =>
  `${OBJECTIVE_TRACKER_PERIOD_BY_ID(trackerId, periodId)}/duplicate`;
export const OBJECTIVE_TRACKER_SUBGOALS = (trackerId, periodId) =>
  `${OBJECTIVE_TRACKER_PERIODS(trackerId)}/${periodId}/subgoals`;
export const OBJECTIVE_TRACKER_NESTED_SUBGOALS = (
  trackerId,
  periodId,
  subgoalId,
) => `${OBJECTIVE_TRACKER_SUBGOALS(trackerId, periodId)}/${subgoalId}`;
export const OBJECTIVE_TRACKER_DUPLICATE_SUBGOAL = (
  trackerId,
  periodId,
  subgoalId,
) =>
  `${OBJECTIVE_TRACKER_NESTED_SUBGOALS(
    trackerId,
    periodId,
    subgoalId,
  )}/duplicate`;
export const OBJECTIVE_TRACKER_BULK_UPLOAD = `${OBJECTIVES_TRACKER}/upload`;

// ***********************************************************************
// Tools - Client platform margins
export const API_CLIENT_PLATFORM_MARGINS =
  "/tools-items/client-platform-margins";
export const API_CLIENT_PLATFORM_MARGINS_BY_ID = (id) =>
  `${API_CLIENT_PLATFORM_MARGINS}/${id}`;
export const API_CLIENT_PLATFORM_MARGINS_CHANGELOG = (id) =>
  `${API_CLIENT_PLATFORM_MARGINS_BY_ID(id)}/changelog`;
export const API_CLIENT_PLATFORM_MARGINS_CHANGELOG_FULL = `${API_CLIENT_PLATFORM_MARGINS}/changelog`;

// ***********************************************************************
// Tools - Datasets Centre
export const API_DATASETS = "/datasets-centre/datasets";
export const API_DATASETS_DETAILS = (id) => `/datasets-centre/datasets/${id}`;
export const API_DATASETS_DIMENSION_TYPES = "/datasets-centre/dimension-types";
export const API_DATASETS_DIMENSIONS = (datasetId) =>
  `/datasets-centre/datasets/${datasetId}/dimensions`;
export const API_DATASETS_DIMENSION_BY_ID = (id) =>
  `/datasets-centre/dimensions/${id}`;
export const API_DATASETS_DIMENSION_BY_BOTH_ID = (datasetId, dimensionId) =>
  `/datasets-centre/datasets/${datasetId}/dimensions/${dimensionId}`;
export const API_DATASETS_METRIC_BY_BOTH_ID = (datasetId, metricId) =>
  `/datasets-centre/datasets/${datasetId}/metrics/${metricId}`;
export const API_DATASETS_METRIC_BY_ID = (id) =>
  `/datasets-centre/metrics/${id}`;
export const API_DATASETS_METRICS = (datasetId) =>
  `/datasets-centre/datasets/${datasetId}/metrics`;
export const API_DATASETS_AGGREGATION_FUNCTIONS =
  "/datasets-centre/aggregation-functions";

// ***********************************************************************
// Tools - Security Centre
export const API_SECURITY_CENTRE_USERS = "/security-centre/users";
export const API_SECURITY_CENTRE_DROPDOWN_ROELS =
  "/security-centre/dropdowns/roles";
export const API_SECURITY_CENTRE_USERS_BY_ID = (id) =>
  `/security-centre/users/${id}`;
export const API_SECURITY_CENTRE_USER_ROLES_BY_ID = (id) =>
  `/security-centre/users/${id}/roles`;
export const API_SECURITY_CENTRE_USER_ROLE_BY_BOTH_ID = (userId, roleId) =>
  `/security-centre/users/${userId}/roles/${roleId}`;
export const API_SECURITY_CENTRE_PERMISSIONS = "/security-centre/permissions";
export const API_SECURITY_CENTRE_PERMISSIONS_BY_ID = (id) =>
  `/security-centre/permissions/${id}`;
export const API_SECURITY_CENTRE_ROLES = "/security-centre/roles";
export const API_SECURITY_CENTRE_ROLES_BY_ID = (id) =>
  `/security-centre/roles/${id}`;
export const API_SECURITY_CENTRE_USERS_BY_ROLE = (id) =>
  `/security-centre/roles/${id}/users`;
export const API_SECURITY_CENTRE_DROPDOWN_DATASETS =
  "/security-centre/dropdowns/permissions/dataapi";
export const API_SECURITY_CENTRE_DATAAPI_PERMISSIONS =
  "/security-centre/permissions/dataapi";
export const API_SECURITY_CENTRE_DATAAPI_PERMISSIONS_BY_ID = (id) =>
  `/security-centre/permissions/dataapi/${id}`;
export const API_SECURITY_CENTRE_NAVBAR_SECTIONS =
  "/security-centre/permissions/controlcentre/navbarSections";
export const API_SECURITY_CENTRE_ROUTES =
  "/security-centre/permissions/controlcentre/routes";
export const API_SECURITY_CENTRE_ACCESSLEVEL =
  "/security-centre/permissions/controlcentre/accessLevel";
export const API_SECURITY_CENTRE_ACCESSLEVEL_BY_ID = (id) =>
  `/security-centre/permissions/controlcentre/accessLevel/${id}`;
export const API_SECURITY_CENTRE_DROPDOWN_SECTIONS =
  "/security-centre/dropdowns/permissions/controlcentre/sections";
export const API_SECURITY_CENTRE_ADD_SECTION = (id) =>
  `/security-centre/permissions/controlcentre/sections/${id}`;
export const API_SECURITY_CENTRE_ROLE_SECTION =
  "/security-centre/permissions/controlcentre/sections/roles";
